<template>
    <div class="page noScroll">
        <h1 v-if="isShowWN" style="display: none;">海洋奇迹号</h1>
        <div class="page-content infinite-scroll noScroll" style="padding-top: 50px;">
            <div class="newsPage-content scroll-container">
                <div class="newsPage-banner">
                    <img src="https://resource.rcclchina.com.cn/newsCenter/detail_banner1.jpg">
                </div>
                <div class="newsPage-title bg-white">
                    <div class="newsPage-title-text">{{newsDetail.newsTitle}}</div>
                    <div class="newsPage-createtime">发布时间：{{newsDetail.createdUtc}}</div>
                </div>
                <div class="newsPage-news-content bg-white" v-html="newsDetail.newsTest"></div>
                <div class="newsPage-others bg-white">
                    <div class="newsPage-others-pre div--inlineBlock">
                        <div v-if="newsDetail.preNewsTitle">
                            <a class="newsPage-others-btn" :href="`/Rccl.CustomPage/RcclNews/Detail/${newsDetail.preNewsId}.html`">上一篇</a>
                            <div class="newsPage-others-title">{{interceptChar(newsDetail.preNewsTitle, 13)}}</div>
                        </div>
                    </div>
                    <div class="newsPage-others-next div--inlineBlock">
                        <div v-if="newsDetail.nextNewsTitle">
                            <a class="newsPage-others-btn" :href="`/Rccl.CustomPage/RcclNews/Detail/${newsDetail.nextNewsId}.html`">下一篇</a>
                            <div class="newsPage-others-title">{{interceptChar(newsDetail.nextNewsTitle, 13)}}</div>
                        </div>
                    </div>
                </div>

                <!-- 爆款推荐 -->
                <div class="shipDetail-hotCruise scroll-container" id="hotCruise">
                    <PromoCruise></PromoCruise>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import { interceptChar } from '@/utilities/tools'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    export default {
        name: 'RcclNewsDetail',
        components: {
            PromoCruise
        },
        data () {
            return {
                userToken: '',
                newsDetail: {}
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '新闻中心')
            this.showPage()
        },
        methods: {
            interceptChar (str, num) {
                return interceptChar(str, num)
            },
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
                const newsId = this.$route.params.id

                this.newsDetail = await this.getDetail(newsId)
                if (this.newsDetail) {
                    const title = this.newsDetail.newsTitle + '|皇家加勒比国际游轮官方网站'
                    const description = this.newsDetail.viewBagSeoDescription
                    const keyword = this.newsDetail.viewBagSeoKeywords
                    this.$store.commit('SET_META', { title, description, keyword })
                }
            },
            async getTitle (newsId) {
                const {success, data, errMsg} = await api.page.getNewsTitle(newsId)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            async getDetail (newsId) {
                const {success, data, errMsg} = await api.page.getNewsDetail(newsId)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            }
        },
        computed: {
            isShowWN () {
                const newsId = this.$route.params.id
                return ["1166239", "1150074", "963306", "931149"].indexOf(newsId) >= 0
            }
        }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }

    /**** news ****/
    .newsPage-banner {
        line-height: 0;
        width:100%;
        height:149px;
        overflow: hidden;
    }

    .newsPage-banner img {
        width: 152%;
        margin-left:-26%;
    }

    .newsPage-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #ddd;
        padding-top: 20px;
    }

    .newsPage-title .newsPage-title-text {
        text-align: center;
        padding: 0 50px;
        font-size: 15px;
        color: #061556;
    }

    .newsPage-title .newsPage-createtime {
        font-size: 12px;
        text-align: center;
        margin-top: 15px;
        color: #777;
    }

    .newsPage-news-content {
        width: 375px;
        overflow-x: hidden;
        padding: 10px;
        color: #222;
        font-size: 12px;
        background-color: white;
    }

    .newsPage-news-content img {
        opacity: 0;
    }

    .newsPage-others {
        padding: 21px 10px 10px 10px;
        position: relative;
        overflow:hidden;
    }
    .newsPage-others .newsPage-others-pre {
        margin-right:10px;
    }
    .newsPage-others .newsPage-others-pre, .newsPage-others .newsPage-others-next {
        width: 170px;
    }

    .newsPage-others .newsPage-others-btn {
        display: block;
        font-size: 13px;
        background-color: #0c77a5;
        color: white;
        text-align: center;
        padding: 8px 0px;
    }

    .newsPage-others .newsPage-others-title {
        font-size: 12px;
        color: #222;
        text-align: center;
        margin-top:10px;
    }

    .shipDetail-hotCruise {
        margin-top: 9px;
        background: white;

    }

    .shipDetail-hotCruise .shipDetail-hotCruise-title {
        padding: 27px 0;
        position: relative;
    }

    .shipDetail-hotCruise .shipDetail-hotCruise-titleLine {
        height: 1px;
        background-color: #fecc46;
    }

    .shipDetail-hotCruise .shipDetail-hotCruise-titleTxt {
        position: absolute;
        top: 18px;
        left: 50%;
        padding: 0 1.867%;
        background-color: #fff;
        text-align: center;
        color: #061556;
        font-size: 13px;
        width: 80px;
        margin-left: -40px;
    }

    .shipDetail-hotCruise .hotCruise-item {
        display: inline-block;
        width: 48.358%;
        position: relative;
        margin-bottom: 2.282%;
    }

    .shipDetail-hotCruise .hotCruise-item:nth-child(2n+1) {
        margin-right: 1.141%;
    }

    .shipDetail-hotCruise .hotCruise-itemPic {
        width: 100%;
        height: 103px;
        overflow: hidden;
    }

    .shipDetail-hotCruise .hotCruise-itemPic img {
        display: block;
        width: 100%;
        position: relative;
        top: -50%;
        left: 0;

    }

    .shipDetail-hotCruise .hotCruise-itemTxt {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        padding-top: 3%;
        background-color: rgba(0,0,0,.4);
    }

    .shipDetail-hotCruise .hotCruise-itemTxt p {
        margin: 0;
        font-size: 9px;
        color: #fff;
        -webkit-transform: scale(.8);
        -moz-transform: scale(.8);
        transform: scale(.8);
        -o-transform: scale(.8);
    }

    .shipDetail-hotCruise .hotCruise-price span {
        font-size: 14px !important;
    }

    .shipDetail-hotCruise .hotCruise-itemBtn {
        position: absolute;
        bottom: 0;
        width: 100%;
        text-align: center;
        background-color: #f0af11;
    }

    .shipDetail-hotCruise .hotCruise-itemBtn a {
        color: #000d57;
        font-size: 13px;
        display: inline-block;
        width: 100%;
    }

    .shipDetail-hotCruise .hotCruise-itemTag {
        position: absolute;
        top: 0;
        right: 4px;
        width: 30.856%;
    }

    .shipDetail-hotCruise .hotCruise-itemTag img {
        width: 100%;
    }

    .shipDetail-hotCruise .hotCruise-itemTagTxt {
        position: absolute;
        top: -3px;
        width: 100%;
        color: #fff;
        font-size: 13px;
        -webkit-transform: scale(.6);
        -moz-transform: scale(.6);
        transform: scale(.6);
        -o-transform: scale(.6);
        text-align: center;
    }

    /**** 爆款推荐 ****/
    .shipDetail-hotCruise {
        background-color: #fff;

        padding-bottom: 50px;
        margin-top:19px;
    }
</style>
